import type { ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'
import { SafeHtmlText } from '../safe-html-text'

export interface FieldErrorAndDescriptionProps {
  description?: ReactNode
  descriptionClassName?: string
  error?: ReactNode
  errorClassName?: string
  className?: string
}

export function FieldErrorAndDescription({
  description,
  descriptionClassName,
  error,
  errorClassName,
  className,
}: FieldErrorAndDescriptionProps) {
  const hasError = Array.isArray(error) ? error.length > 0 : Boolean(error)

  return hasError || description ? (
    <div className={twMerge('grid gap-2', className)}>
      {description ? (
        <span
          className={twMerge('link-container text-text-tertiary text-sm', descriptionClassName)}
        >
          {description}
        </span>
      ) : null}
      {hasError && typeof error === 'string' ? (
        <SafeHtmlText
          as="p"
          className={twMerge('text-text-error text-sm whitespace-pre-line', errorClassName)}
          html={error}
        />
      ) : hasError ? (
        <p className={twMerge('link-container text-text-error text-sm', errorClassName)}>{error}</p>
      ) : null}
    </div>
  ) : null
}
